export const POST_AI_MARKUP_DATA = "POST_AI_MARKUP_DATA"
export const POST_AI_MARKUP_DATA_SUCCESS = "POST_AI_MARKUP_DATA_SUCCESS"
export const POST_AI_MARKUP_DATA_FAIL = "POST_AI_MARKUP_DATA_FAIL"

//update data
export const UPDATE_AI_MARKUP_DATA = "UPDATE_AI_MARKUP_DATA"

//get aiMarkup data
export const GET_AI_MARKUP_DATA = "GET_AI_MARKUP_DATA"
export const GET_AI_MARKUP_DATA_SUCCESS = "GET_AI_MARKUP_DATA_SUCCESS"
export const GET_AI_MARKUP_DATA_FAIL = "GET_AI_MARKUP_DATA_FAIL"